import React from "react";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

interface DashboardCardProps {
  name?: string;
  det?: number;
  Icon?: any;
  gradient?: string;
  theme?: "light" | "dark";
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  name,
  det,
  Icon,
  gradient = "from-primary to-primaryLight",
  theme = "light",
}) => {
  const isDark = theme === "dark";
  
  return (
    <div className={`rounded-2xl shadow-lg border p-6 hover:shadow-xl transition-all duration-300 ${
      isDark 
        ? "bg-slate-800 border-slate-700 shadow-slate-900/50" 
        : "bg-white border-slate-100 shadow-slate-200/50"
    }`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className={`text-sm font-medium mb-1 ${
            isDark ? "text-slate-400" : "text-slate-500"
          }`}>{name}</p>
          <p className={`text-3xl font-bold ${
            isDark ? "text-slate-100" : "text-slate-800"
          }`}>{det?.toLocaleString()}</p>
          <div className="flex items-center gap-1 mt-2">
            <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
              isDark 
                ? "bg-emerald-900/30 text-emerald-400 border border-emerald-800/50" 
                : "bg-emerald-50 text-emerald-600"
            }`}>
              <TrendingUpIcon sx={{ fontSize: 14 }} />
              <span>{det}%</span>
            </div>
            <span className={`text-xs ${
              isDark ? "text-slate-500" : "text-slate-400"
            }`}>vs last month</span>
          </div>
        </div>
        <div
          className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg`}
        >
          {Icon && <Icon className="text-white" sx={{ fontSize: 28 }} />}
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
